<template>
<div>
  <v-row>
    <v-col>
      <v-container pb-4 grid-list-xl>
        <v-layout row wrap class="user-detailboxmain fixed-depositbox">
          <v-flex class="user-detailbox equityListbox bond-equitybox">
            <v-list-item v-for="reccuringDetails in savingAccountData" :key="reccuringDetails.id">
              <v-list-item-content>
                <v-list-item-title>
                  <h3 v-if="reccuringDetails.name">{{reccuringDetails.name}}</h3>
                  <h3 v-else>Account owner name is N/A</h3>
                </v-list-item-title>
                <v-list-item-subtitle v-for="savingAccountDatas in reccuringDetails.description" :key="savingAccountDatas.id">
                  <div class="edit-box">
                    <v-col class="memberbox-editbox">
                    <v-menu bottom left offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          outlined fab
                          color="#F19700"
                          v-bind="attrs"
                          v-on="on"
                          @click="showHide(savingAccountDatas['form_id'])"
                          v-if="allow_user_activity =='yes'"
                        >
                          <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                        </v-btn>
                      </template>
                      <v-list v-if="(hideShowId == savingAccountDatas['form_id'])">
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="editAccounts(savingAccountDatas['form_id'])">
                              <v-img
                              max-height="20"
                              max-width="20"
                              :src="edit_pic"
                              :lazy-src="edit_pic"
                              ></v-img> Edit
                            </v-btn>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn @click="deleteAccounts(savingAccountDatas['form_id'])">
                              <v-img
                              max-height="23"
                              max-width="19"
                              :src=" delete_pic"
                              :lazy-src=" delete_pic"
                              > </v-img>Delete
                            </v-btn>
                          </v-list-item-title>
                        </v-list-item>
                          <v-list-item>
                      <v-list-item-title>
                        <v-btn
                          @click="updateBalance(savingAccountDatas)"
                        >
                          <v-img
                            max-height="23"
                            max-width="19"
                            :src="update_pic"
                            :lazy-src="update_pic"
                          >
                          </v-img
                          >Update Details
                        </v-btn>
                      </v-list-item-title>
                    </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                  </div>
                  <div class="account-detailbox">
                      <div class="bank-name">
                        <h5 v-if="savingAccountDatas.bank_name">{{savingAccountDatas.bank_name}}</h5>
                        <h5 v-else>Bank name is unavailable</h5>
                        <p v-if="savingAccountDatas.loan_account_no">{{savingAccountDatas.loan_account_no}}</p>
                        <p v-else>Account number is unavailable</p>
                      </div>
                      <div class="amount-box">
                        <span>Loan Amount
                        </span>
                        <p><span> &#8377;</span>{{savingAccountDatas.loan_amount}}</p>
                      </div>
                  </div>
                  <div class="maturity-Datebox">
                      <div class="bank-name">
                        <span>Start Date</span>
                        <p v-if="savingAccountDatas.start_date">{{savingAccountDatas.start_date}}</p>
                        <p v-else>Start Date is unavilable</p>
                      </div>
                      <div class="amount-box">
                        <span>
                        Loan Balance as on {{savingAccountDatas.loan_outstanding_date}}
                        </span>
                        <p><span> &#8377;{{savingAccountDatas.loan_balance}}</span></p>
                      </div>
                  </div>
                  <div class="maturity-Datebox Rate-of-Interest">
                      <div class="bank-name">
                        <span>Expiry Date</span>
                        <p v-if="savingAccountDatas.expiry_date">{{savingAccountDatas.expiry_date}}</p>
                        <p v-else>Expiry Date is unavailable</p>
                      </div>
                      <div class="amount-box">
                        <span>
                          EMI Amount
                        </span>
                        <p><span> &#8377;</span> {{savingAccountDatas.emi_amount}}    </p>
                      </div>
                  </div>
                    <div class="maturity-Datebox Rate-of-Interest">
                        <div class="bank-name">
                            <span>Rate of Interest</span>
                            <p v-if="savingAccountDatas.interest_rate">{{savingAccountDatas.interest_rate}} %</p>
                            <p v-else>Rate of interest is unavailable</p>
                        </div>
                        <div class="bank-name">
                            <span>EMI Date</span>
                            <p v-if="savingAccountDatas.emi_date">{{Number(savingAccountDatas.emi_date)}}th</p>
                            <p v-else>EMI Date is unavailable</p>
                        </div>
                    </div>
                    <div class="maturity-Datebox">
                        <div class="bank-name">
                            <span>Joint A/c Owner</span>
                          <p v-if="savingAccountDatas.joint_account_owner">{{savingAccountDatas.joint_account_owner}}</p>
                          <p v-else>Joint A/c Owner is unavailable</p>
                        </div>
                        <div class="bank-name">
                            <span>Insurance</span>
                            <p v-if="savingAccountDatas.insurance">{{savingAccountDatas.insurance}} </p>
                            <p v-else>Insurance is unavailable</p>
                        </div>
                    </div>
                </v-list-item-subtitle> 
                
              </v-list-item-content>  
            </v-list-item>
          </v-flex>
        </v-layout>  
      </v-container>  
    <div class="total-amount-box" v-if="savingAccountData.length != 0">
        <h4>Total Car Loan Balance</h4>
        <div class="total-amount">
            <span>As on {{currentDate | moment("DD MMM, YYYY")}}</span>
            <p><span> &#8377;</span>{{amount.toLocaleString()}}</p>
        </div>
    </div>
    <div v-else>
      <v-list-item>
        <div class="user-detailbox">
          <v-list-item-content>
            <div class="text-h5 mb-1">
              No data found.
            </div>
          </v-list-item-content>
        </div>
      </v-list-item>
    </div>
    </v-col>
</v-row>
    <v-dialog v-model="dialogUpdateBalance" width="900">
      <v-card class="term-modal">
        <v-card-title class="text-h5">
          Update Details
          <v-card-actions class="close-icon">
            <v-btn color="primary" text @click="dialogSecond = false">
              <v-img
                width="20"
                height="20"
                @click="closeModal"
                style="float: right"
                :src="require('@/assets/images/cross.png')"
              >
              </v-img>
            </v-btn>
          </v-card-actions>
        </v-card-title>
        <v-card-text>
            <v-form
              ref="updateBalanceForm"
             
              @submit.prevent="updateLoanBalance"
              lazy-validation
            >
             

              <v-text-field
                type="number"
                v-model="update_balance"
                value=""
                :rules="[(v) => !!v || 'Field is required']"
                placeholder="Enter Loan Amount"
                label="Loan Amount(₹)" 
              >
              </v-text-field>

              <v-text-field
                  type="number"
                  v-model="loan_balance"
                  value=""
                  :rules="[(v) => !!v || 'Field is required']"
                  placeholder="Enter Loan Balance"
                  label="Loan Balance(₹)" 
              >
              </v-text-field>

              <v-text-field
                type="number"
                v-model="emi_amount"
                value=""
                :rules="[(v) => !!v || 'Field is required']"
                placeholder="Enter EMI Amount"
                label="EMI Amount(₹)"
               
              >
              </v-text-field>

              <v-text-field
                type="number"
                v-model="interest_rate"
                value=""
                :rules="[(v) => !!v || 'Field is required']"
                placeholder="Enter Interest Rate"
                label="Interest Rate(%)"
                
              >
              </v-text-field>

               <v-select
                v-model="emi_due_date"
                :items="emi_date_list"
                :rules="[v => !!v || 'Item is required']"
                item-value="id"
                item-text="name"
                name = "emi_due_date"
                id   = "emi_due_date"
                label="Select EMI Date"
                :value="emi_due_date"
              ></v-select>

              <v-btn
                color="warning"
                class="mr-4"
                type="submit"
              >
                Update
              </v-btn>
            </v-form>   
        </v-card-text>
      </v-card>
    </v-dialog>
</div>
</template>
<script>
    import { Auth } from "aws-amplify";
    import { GET_LIABILITY_FORM_DETAIL, DELETE_LIABILITY_FORM } from "../../../store/actions.type";
    import { isEmpty } from 'lodash';
    import axios from "axios";
    export default {
        data() {
            return {
               loan_balance:'',
                three_dots: process.env.VUE_APP_ROOT_ICONS_URL + "three_dots.png",
                currentDate: new Date().setDate(new Date().getDate()),
                edit_pic: process.env.VUE_APP_ROOT_ICONS_URL + "edit.png",
                delete_pic: process.env.VUE_APP_ROOT_ICONS_URL + "delete.png",
                update_pic: process.env.VUE_APP_ROOT_ICONS_URL + "update.png",
                hideShow: false,
                hideShowId: "",
                update_balance: "",
                full_name: "",
                allow_user_activity:localStorage.getItem('allow_user_activity'),
                emi_amount:'',
                interest_rate:'',
                emi_due_date:'',
                emi_date_list:[],
                dialogUpdateBalance:false
            };
        },
        created() {
            Fire.$on("loadData", () => {
            this.savingAccountList();
          });
        },
        mounted() {
            if(this.isDataEmpty ) this.savingAccountList();
            let i;
            for(i =1; i<=30; i++){
              if(i<=9){
                 this.emi_date_list.push({'id':'0'+i, 'name':'0'+i})
              }
              else{
                 this.emi_date_list.push({'id':i.toString(), 'name':i.toString()})
              }
            }
        },
        computed: {
          isDataEmpty: function () {
            return isEmpty(this.$store.getters.getLiabilityFormDetail);
          },
          savingAccountData: function () {
            return !this.isDataEmpty ? this.$store.getters.getLiabilityFormDetail.data.car_loan_detail : [];
          },
          amount: function () {
            let amount = 0;
            this.savingAccountData.forEach(details => {
              amount +=  parseInt(details.total_balance);
            })
            return amount;
          }
        },
        methods: {
           
            showHide(id) {
                this.hideShowId = id;
                this.hideShow = this.hideShow ? false : true;
            },
            closeModal() {
              this.dialogUpdateBalance = false
            },
            close() {
              this.$modal.hide("update-balance");
            },
            updateBalance(savingData) {
              this.loan_balance = savingData.loan_balance
              this.emi_amount = savingData.emi_amount
              this.update_balance = savingData.loan_amount
              this.interest_rate = savingData.interest_rate
              this.emi_due_date = savingData.emi_date
              this.dialogUpdateBalance = true
              this.form_id = savingData.form_id;
            },
            updateLoanBalance(){
                if(this.$refs.updateBalanceForm.validate()){
                  let formdata = new FormData();
                  formdata.append(
                    "aws_cognito_id",
                    atob(localStorage.getItem("cognito_idp"))
                  );
                  formdata.append("form_id", this.form_id);
                  formdata.append("loan_balance",this.update_balance);
                  formdata.append("interest_rate",this.interest_rate);
                  formdata.append("emi_amount",this.emi_amount);
                  formdata.append("emi_date",this.emi_due_date);
                  formdata.append("module_type", 'home_loan');
                  formdata.append("actual_loan_balance",this.loan_balance);
                  axios
                    .post(
                      process.env.VUE_APP_ROOT_API + "update-liabilities-balance",
                      formdata
                    )
                    .then((res) => {
                      this.$modal.hide("update-balance");
                       this.dialogUpdateBalance = false
                      swal.fire({
                        title:"Balance Updated Successfully",
                        icon:'success'
                      })
                     this.savingAccountList();
                    })
                    .catch(() => {});
                }
            },
            editAccounts(editId) {
                 this.$router.push({ path: "/car-loan-edit/"+btoa(editId) }).catch(()=>{});
            },
            deleteAccounts(id) {
                swal.fire({
                    title: "Are you sure, you want to delete this data?",
                    showCancelButton: true,
                    confirmButtonColor: `#051d42`,
                    confirmButtonText: `YES`,
                    cancelButtonColor: `#f19700`,
                }).then((result) => {
                    if (result.isConfirmed) {
                        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
                        this.$store
                            .dispatch(DELETE_LIABILITY_FORM, {
                                data: {
                                    aws_cognito_id: cognito_idp,
                                    form_id: id,
                                },
                                api: "delete-form",
                            })
                            .then(() => {
                                this.savingAccountList();                                 
                                Toast.fire({
                                    icon: "success",
                                    title: "Data deleted successfully.",
                                });
                            });
                    } else if (result.isDenied) {
                        Swal.fire("Changes are not saved", "", "info");
                    }
                });
            },
            savingAccountList() {
                this.$loading(true);
                let cognito_idp = atob(localStorage.getItem('cognito_idp'));
                let user_name = this.$store.getters.getUserDetails.user_name;
                let selected_value = this.$store.getters.getUserDetails.selected_value;
                this.$store
                    .dispatch(GET_LIABILITY_FORM_DETAIL, {
                        data: {
                            aws_cognito_id: cognito_idp,
                            user_name: user_name,
                            member_id: selected_value,
                        },
                        api: "get-liability-form-detail",
                    })
                    .then((response) => {
                         Fire.$emit("updateLiabilityData");
                        this.$loading(false);
                    })
                    .catch(() => {
                        this.$loading(false);
                    });
            },
        },
    };
</script>
